// extracted by mini-css-extract-plugin
export default {"content":"CatalogWidget-module__content--jQBGh"};